<template>
  <div class="wrapper">
    <section class="answer-one answer">
      <div class="container answer__container">
        <div class="answer__block--title">
          <span class="levels__love-bg">
            <picture>
              <source srcset="~@/assets/img/level-love-1.avif" type="image/avif">
              <source srcset="~@/assets/img/level-love-1.webp" type="image/webp">
              <img loading="lazy" src="~@/assets/img/level-love-1.png" class="image" width="54" height="166" alt="Love">
            </picture>
          </span>
          <h2 class="answer__title">Уровень 1</h2>
          <p class="answer__subtitle">Болезненный:</p>
        </div>
        <div class="answer__content">
          <div class="process-bar__label">Потенциал любовной энергии</div>
          <div class="process-bar">
            <div class="process-bar__line result-1"></div>
            <div class="process-bar__value">94%</div>
          </div>
          <div class="process-bar-listing">
            <div class="process-bar-listing__title">Любовная энергия на данный момент:</div>
            <div class="process-bar-list__label">Любовь к себе</div>
            <div class="process-bar-list">
              <div class="process-bar-list__line result-1_list_1"></div>
              <div class="process-bar-list__value">7%</div>
            </div>
            <div class="process-bar-list__label">Любовь к окружающим </div>
            <div class="process-bar-list">
              <div class="process-bar-list__line result-1_list_2"></div>
              <div class="process-bar-list__value">17%</div>
            </div>
            <div class="process-bar-list__label">Любовь к жизни</div>
            <div class="process-bar-list">
              <div class="process-bar-list__line result-1_list_3"></div>
              <div class="process-bar-list__value">11%</div>
            </div>
          </div>
          <div class="text-icon">
            <img src="@/assets/img/svg/icon_1_text.svg" />
            <p>Ваш потенциал любовной энергии восхищает! По ответам видно, что вы действительно <span>готовы любить и быть любимой.</span> </p>
          </div>
          <p class="answer__content--text">Вы — восприимчивая личность, которая способна глубоко чувствовать
            и проживать свою жизнь по максимуму. При этом я вижу, что на данный момент уровень вашей
            энергии любви болезненный. Вы склонны недооценивать себя и свои достижения.
            Иногда вам кажется, что вы просто не достойны партнера, в связи с чем на
            интуитивном уровне вы можете притягивать по- настоящему недостойных мужчин.
            В результате они причиняют вам боль и оставляют психологические травмы.
          </p>
          <div class="text-icon icon-top m28">
            <img src="@/assets/img/svg/icon_2_text.svg" />
            <p>Пока вы не научитесь <span>любить себя и быть собой,</span> вы не сможете состоять в отношениях с надежным и хорошим человеком в течение продолжительного времени. </p>
          </div>
          <p class="answer__content--text no-margin">Ведь даже самого любящего и доброго мужчину насторожит ваша нелюбовь к себе. Так что на данный момент вам нужно научиться любить себя.</p>
          <p class="answer__content--text m28">Почему у вас могут быть напряженные сексуальные и романтические связи?
            Причина в том, что ваш болезненный уровень не позволяет строить гармоничные отношения.
            А это может повлечь за собой одиночество и непостоянство в личной жизни.
            Проще говоря, вы можете так и не обрести любовь.
            Поэтому <span>вам необходимо поднимать свой уровень любовной энергии и двигаться вперед.</span></p>
          <div class="block-text">
            <div class="block-text__title">Высокий уровень любви даст вам:</div>
            <div class="block-text__text">— здоровую самооценку;
            </div>
            <div class="block-text__text">
              — умение любить себя такой, какая вы есть;
            </div>
            <div class="block-text__text">
              — способность быть любимой;
            </div>
            <div class="block-text__text">
              — счастливые отношения;
            </div>
            <div class="block-text__text">
              — внутреннее равновесие;
            </div>
            <div class="block-text__text">
              — избавление от одиночества.
            </div>
          </div>
          <div class="rs-title">Персональные рекомендации для вас:</div>
          <div class="rs-block">
            <div class="rs-block__table">
              <div class="rs-block__number">01</div>
              <div class="rs-block__subtitle">Аффирмации для развития любви к себе. </div>
            </div>
            <div class="rs-block__text">Становитесь перед зеркалом каждый день и проговаривайте вслух: “Я красива. Я умна. Я успешна. Я люблю себя такой, какая есть. Я ценю свои достоинства. Я борюсь со своими недостатками. Я принимаю и уважаю себя”.</div>
          </div>
          <div class="rs-block">
            <div class="rs-block__table">
              <div class="rs-block__number">02</div>
              <div class="rs-block__subtitle icon_number"> Амулет
                <br />“Энергия любви”.</div>
            </div>
            <div class="rs-block__text icon_end">Методом индивидуального заряда он настраивается под энергетику своей носительницы и начинает воздействовать на нее. В первую очередь руническая формула браслета влияет на развитие любви к себе и принятие своего Я. Вы сможете выявить свои истинные потребности и желания, понять, что вам действительно нужно в личной жизни, и придете к гармонии
              с собой. <br>Как работает амулет и чем он вам поможет — читайте тут
            </div>
            <div class="more">
              <a class="info__button btn_rs btn" :href="url" onclick="ym(56736205,'reachGoal','amuletslovetest')">Заказать амулет</a>
            </div>
          </div>
          <div class="rs-block">
            <div class="rs-block__table">
              <div class="rs-block__number">03</div>
              <div class="rs-block__subtitle"> “Дневник гордости”. </div>
            </div>
            <div class="rs-block__text">Заведите специальную тетрадь и каждый день записывайте туда по датам то, чем вы гордитесь. Все незначительные удачи и маленькие победы своего дня до мельчайших подробностей. Не ленитесь вести записи ежедневно!</div>
          </div>
        </div>
      </div>
    </section>
    <FooterResult />
  </div>
</template>

<script>
import FooterResult from "@/components/FooterResult";
export default {
  name: "Result1",
  components: { FooterResult },
  computed: {
    utm() {
      return this.$store.getters['utm']
    },
    url() {
      let link = 'https://store.taroirena.ru/shop/amulety/braslet-energiya-lyubvi/'
      if(this.utm.utm_source) {
        link += '?utm_source=' + this.utm.utm_source
      }
      if(this.utm.utm_medium) {
        link += '&utm_medium=' + this.utm.utm_medium
      }
      if(this.utm.utm_campaign) {
        link += '&utm_campaign=' + this.utm.utm_campaign
      }
      if(this.utm.utm_content) {
        link += '&utm_content=' + this.utm.utm_content
      }
      if(this.utm.utm_term) {
        link += '&utm_term=' + this.utm.utm_term
      }
      return link
    }
  }
}
</script>